export default "__VITE_ASSET__DFdXt_0i__"